import { Product } from '@axo/shared/data-access/types';
import finlandStep1Schema from '../forms/Finland/LoanApplication/config/schemas/Finland.Step1.schema';
import { TFormFields } from './formFields/formFields.d';

const formSchemas: TFormFields = {
  SE: {
    [Product.UnsecuredLoan]: [],
  },
  DK: {
    [Product.UnsecuredLoan]: [],
  },
  NO: {
    [Product.UnsecuredLoan]: [],
    [Product.CreditCard]: [],
  },
  FI: {
    [Product.UnsecuredLoan]: [finlandStep1Schema],
  },
};

export default formSchemas;
